@if (item()?.collateral_item_type_key === 'ship') {
  <a
    [href]="item().external_url"
    target="_blank"
    [tooltip]="'company_collateral.ship_item_link_tooltip' | translate"
    class="tag tag-dense text-primary small">
    <i class="fa fa-ship mx-1"></i>
    <span class="mx-1">
      {{ item().ship_name || item().call_sign || item().imo_number }}
    </span>
  </a>
}

@if (item()?.collateral_item_type_key === 'vehicle') {
  <a
    [href]="item().external_url"
    [tooltip]="'company_collateral.vehicle_item_link_tooltip' | translate"
    target="_blank"
    class="tag tag-dense text-primary small">
    <i class="fa fa-car mx-1"></i>
    <span class="mx-1">{{ item().vehicle_registration_number }}</span>
  </a>
}
